/* File Error Module */
import { FeatureError } from '@/libs/errors/FeatureError';
import { T } from '@/libs/translation';

/** @description 파일 타입이 허용하지 않는 타입입니다*/
export const FILE_001 = (type: string, error?: Error) =>
  new FeatureError(
    {
      title: T('file.error.001_title', { type }),
      message: T('file.error.001_message', { type }),
      code: 'FILE_001',
    },
    error,
  );

/** @description 이미지 매직 auto-orient 에러*/
export const FILE_002 = (type: string, error?: Error) =>
  new FeatureError(
    {
      title: T('file.error.002_title', { type }),
      message: T('file.error.002_message', { type }),
      code: 'FILE_002',
    },
    error,
  );

/** @description 이미지 S3 업로드 실패*/
export const FILE_003 = (error?: unknown) =>
  new FeatureError(
    {
      title: T('file.error.003_title'),
      message: T('file.error.003_message'),
      code: 'FILE_003',
    },
    error,
  );

/** @description 파일이 들어오지 않음*/
export const FILE_004 = (error?: unknown) => {
  return new FeatureError(
    {
      title: T('file.error.004_title'),
      message: T('file.error.004_message'),
      code: 'FILE_004',
    },
    error,
  );
};
